import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from '../../services/permissions.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
    readonly SettingsOption = SettingsOption;
    selectedComponent!: SettingsOption;

    componentMapping: Record<SettingsOption, string> = {
        [SettingsOption.CERERE_STATUS]: 'app-status',
        [SettingsOption.CERERE_PRIORITY]: 'app-cerere-priority',
        [SettingsOption.CERERE_TYPE]: 'app-request-types',
        [SettingsOption.ZILE_LIBERE]: 'app-zile-libere',
        [SettingsOption.LOCATII]: 'app-locatii',
        [SettingsOption.MODULE]: 'app-module',
        [SettingsOption.MODULE_TIPURI_PROGRAM]: 'app-module-tipuri-program',
        [SettingsOption.MODULE_TIPURI_PROGRAM_ACTIVE]: 'app-module-tipuri-program-active',
        [SettingsOption.MODULE_LOCATII_ACTIVE]: 'app-module-locatii-active',
        [SettingsOption.DOCUMENT_CATEGORY]: 'app-document-category',
        [SettingsOption.DOCUMENT_TYPE]: 'app-document-type',
        [SettingsOption.OPERATORI]: 'app-operatori',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.status-cerere.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CERERE_STATUS
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.prioritati-cerere.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CERERE_PRIORITY
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.tip-cerere.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.CERERE_TYPE
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.zile-libere.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.ZILE_LIBERE
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.locatii.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.LOCATII
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.module.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.MODULE
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.module-tipuri-program.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.MODULE_TIPURI_PROGRAM
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.module-tipuri-program.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.MODULE_TIPURI_PROGRAM_ACTIVE
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.module-locatii-active.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.MODULE_LOCATII_ACTIVE
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.categorii-documente.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_CATEGORY
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.tipuri-documente.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.DOCUMENT_TYPE
            );
        };
        if (
            !this.permissionsService.hasPermission(
                'deps-module.settings.operatori.list'
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== SettingsOption.OPERATORI
            );
        };
    }
}
